import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import PrintIcon from '@mui/icons-material/Print';
import Info from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';
import ReactDOM from 'react-dom';
import CheckOutReceiptPrint from '../RoomRegister/CheckOutPrint';



function RoomRegisterIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);  // Modal state

    const history = useHistory();
    const { isAuthenticated, companyId, branchId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();

            return;
        }
        // Token is not expired, fetch data
        fetchtableData();
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        setLoading(true);
    }, [isAuthenticated, companyId, branchId, userId, token, logout]);


    const fetchtableData = async () => {
        setLoading(true);
        fetchData('RoomRegistrationApi', `/${fromDate}/${toDate}/${companyId}/${branchId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);

                }
                console.log(response);
            })

            .catch((error) => {
                console.error('Error fetching Item:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleDelete = async () => {
        deleteData('ItemApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('ItemApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => { 
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };


    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };


    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };
    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    // print 
    const handlePrint = async (receiptId) => {
        try {
            if (!receiptId) {                
                return;
            }
            const response = await fetchData('RoomRentPaymentApi', `/ReceiptPrint/${receiptId}/${branchId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            // Create and configure the iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            // Wait for the iframe to initialize
            iframe.onload = () => {
                const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

                // Create a container element for React rendering
                const container = iframeDocument.createElement('div');
                iframeDocument.body.appendChild(container);

                // Render the CheckOutReceiptPrint component into the container
                ReactDOM.render(
                    <CheckOutReceiptPrint
                        labelData={labelData}
                        onClose={() => document.body.removeChild(iframe)} // Cleanup
                    />,
                    container
                );

                // Trigger the print function
                setTimeout(() => {
                    iframe.contentWindow.print();
                }, 500); // Short delay to ensure content is rendered
            };

            // Trigger iframe load by opening and closing the document
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.open();
            iframeDocument.close();
        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };



    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>BOOKING DETAILS

                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '170px' : '140px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            marginLeft: '10px'
                        }}
                    />
                </h6>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px', marginTop: '-5px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px', marginTop: '-5px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>

                <Tooltip
                    title="Refresh For Data Load"
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: 'darkolivegreen',
                                color: 'white',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ backgroundColor: '#C9E9D2', color: "black", height: '36px', marginLeft: '10px', marginTop: '17px' }}
                        onClick={fetchtableData}
                        className="linkcolor"
                    >
                        <span>Refresh</span>
                    </Button>
                </Tooltip>

            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'hidden' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#C1BAA1' }}>

                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#ECEBDE', borderBottom: '1px solid #F5F5F5', color: 'darkred', fontWeight: 'bolder', padding: '5px' }}>Sl.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#ECEBDE', borderBottom: '1px solid #F5F5F5', color: 'darkred', fontWeight: 'bolder', padding: '5px' }}>Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#ECEBDE', borderBottom: '1px solid #F5F5F5', color: 'darkred', fontWeight: 'bolder', padding: '5px' }}>Room</TableCell>
                                <TableCell sx={{ backgroundColor: '#ECEBDE', borderBottom: '1px solid #F5F5F5', color: 'darkred', fontWeight: 'bolder', padding: '5px' }}>Room Type</TableCell>
                                <TableCell sx={{ backgroundColor: '#ECEBDE', borderBottom: '1px solid #F5F5F5', color: 'darkred', fontWeight: 'bolder', padding: '5px' }}>Check-IN</TableCell>
                                <TableCell sx={{ backgroundColor: '#ECEBDE', borderBottom: '1px solid #F5F5F5', color: 'darkred', fontWeight: 'bolder', padding: '5px' }}>Check-Out</TableCell>
                                <TableCell sx={{ backgroundColor: '#ECEBDE', borderBottom: '1px solid #F5F5F5', color: 'darkred', fontWeight: 'bolder', padding: '5px' }}>Total Days</TableCell>
                                <TableCell sx={{ backgroundColor: '#ECEBDE', borderBottom: '1px solid #F5F5F5', color: 'darkred', fontWeight: 'bolder', padding: '5px', textAlign: 'right' }}></TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData.map((item, index) => (
                                <TableRow
                                    key={index}
                                    className="border-b"
                                    style={{
                                        backgroundColor: item.Isvacated
                                            ? index % 2 === 0
                                                ? '#F7FAFF'
                                                : '#FFFFFF'
                                            : '#FFCCCC', // Light red for rows where Isvacated is false
                                        borderBottom: '1px solid #E0E0E0',
                                        cursor: 'pointer',
                                        position: 'relative',
                                        overflow: 'hidden',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = item.Isvacated
                                            ? '#E1F0DA' // Light wave color
                                            : '#FF9999'; // Slightly darker red for Isvacated false
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = item.Isvacated
                                            ? index % 2 === 0
                                                ? '#F7FAFF'
                                                : '#FFFFFF'
                                            : '#FFCCCC'; // Reset color on hover out
                                    }}
                                >
                                    {/* Table cells */}
                                    <TableCell
                                        style={{
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            padding: '1px',
                                            textAlign: 'left',
                                            width: '65px',
                                        }}
                                    >
                                        {index + 1}
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            padding: '3px',

                                        }}
                                    >
                                        {item.FirstName}  {item.LastName}
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            padding: '3px',

                                        }}
                                    >
                                        {item.RoomName}
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            padding: '3px',

                                        }}
                                    >
                                        {item.SlabName}
                                    </TableCell>
                                    <TableCell sx={{ height: '25px', padding: '5px', width: '9%' }}>{formatDate(item.CheckIn)}</TableCell>
                                    <TableCell sx={{ height: '25px', padding: '5px', width: '9%' }}>{item.Isvacated ? formatDate(item.CheckOut) : ''}</TableCell>
                                    <TableCell sx={{ height: '25px', padding: '5px', width: '9%' }}>{item.TotalStay}</TableCell>
                                    <TableCell
                                        style={{
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            padding: '3px',
                                            textAlign: 'right'
                                        }}
                                    >


                                        {item.Isvacated === true && (
                                            <IconButton onClick={() => handlePrint(item.RoomRentId)}>
                                                <PrintIcon style={{
                                                    height: '23px',
                                                    color: 'darkmagenta',
                                                    marginTop: '-5px'
                                                }} />
                                            </IconButton>
                                        )}

                                        <IconButton component={Link} to={`/RoomRegisterDetails/${item.Id}`} color="warning">
                                            <Info />
                                        </IconButton>

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete ?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>

            </div>
        </div>
    );
}

export default RoomRegisterIndex;
